import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ReactCarousel from '../ReactCarousel';
import './ColumnCarousel.scss';

const defaultSettings = {
  dots: true,
  infinite: false,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '15px 0 20px',
};

const ColumnCarouselItems = ({ settings, enableSlider, children }) => {
  let body = children;
  if (enableSlider) {
    body = (
      <ReactCarousel settings={settings}>
        {children}
      </ReactCarousel>
    );
  }
  return (
    <div className={cx('column-carousel__wrapper', {
      'column-carousel__wrapper--slider': enableSlider,
    })}>
      {body}
    </div>
  );
};

const ColumnCarousel = ({ title, cta, href, settings, enableSlider, bypass, children }) => {
  const carouselSettings = {
    ...defaultSettings,
    ...settings
  };

  const items = bypass ? children : React.Children.map(children, child => {
    if (!child) {
      return null;
    }
    return (
      <div className="column-carousel__item">
        {child}
      </div>
    );
  });

  return (
    <div className="column-carousel">
      {(title || (cta && href)) && (
        <header className="column-carousel__header">
          <h4 className="text-kilo bold column-carousel__title">{title}</h4>
          {cta && href && <a href={href} className="column-carousel__link">{cta}</a>}
        </header>
      )}
      <ColumnCarouselItems
        settings={carouselSettings}
        enableSlider={!bypass && enableSlider}>
        {items}
      </ColumnCarouselItems>
    </div>
  );
};

ColumnCarouselItems.propTypes = {
  settings: PropTypes.shape({
    dots: PropTypes.bool,
    infinite: PropTypes.bool,
    speed: PropTypes.number,
    slidesToShow: PropTypes.number,
    slidesToScroll: PropTypes.number,
  }),
  enableSlider: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ColumnCarousel.propTypes = {
  ...ColumnCarouselItems.propTypes,
  title: PropTypes.string.isRequired,
  cta: PropTypes.string,
  href: PropTypes.string,
};

export default ColumnCarousel;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ColumnCarousel/ColumnCarousel.js